export default __webpack_public_path__ + "static/media/milestone 1400.56bc22d9.svg";